import { Box, Divider } from '@mui/material';
import { FC, ReactNode } from 'react';

import { DropdownSelectRow, DropdownSelectRowProps } from './DropdownSelectRow';

export type DropdownSelectExpandableRowProps = {
  expandedContent?: ReactNode;
} & DropdownSelectRowProps;

export const DropdownSelectExpandableRow: FC<DropdownSelectExpandableRowProps> = ({
  children,
  expandedContent,
  ...props
}) => {
  const isExpanded = !!expandedContent;

  return (
    <Box>
      <Divider
        sx={{
          transition: 'all .2s',
          borderColor: isExpanded ? undefined : 'transparent',
          mb: isExpanded ? 1 : 0,
        }}
      />
      <DropdownSelectRow {...props}>{children}</DropdownSelectRow>
      {expandedContent}
      <Divider
        sx={{
          transition: 'all .2s',
          borderColor: isExpanded ? undefined : 'transparent',
          mt: isExpanded ? 1 : 0,
        }}
      />
    </Box>
  );
};
